import { useState, useCallback } from "react";

// ─────────────────────────────────────────────────────────────
//  useToast
//
//  Hook qui expose :
//    toast.success(message)  → toast vert
//    toast.error(message)    → toast rouge
//    toast.info(message)     → toast bleu
//
//  Et la liste `toasts` à passer au <ToastContainer />.
//
//  Usage :
//    const { toasts, toast } = useToast();
//    toast.success("Profil enregistré !");
// ─────────────────────────────────────────────────────────────

export function useToast() {
  const [toasts, setToasts] = useState([]);

  // Ajoute un toast et le supprime automatiquement après `duration` ms
  const addToast = useCallback((message, type = "success", duration = 3500) => {
    const id = Date.now(); // ID unique basé sur le timestamp

    setToasts(prev => [...prev, { id, message, type }]);

    // Suppression automatique après la durée
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, duration);
  }, []);

  // Suppression manuelle (clic sur le ×)
  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  // Raccourcis par type
  const toast = {
    success: (msg) => addToast(msg, "success"),
    error:   (msg) => addToast(msg, "error"),
    info:    (msg) => addToast(msg, "info"),
  };

  return { toasts, toast, removeToast };
}
